<template>
  <div class="footer-container">
    <div class="footer-content">
      <div class="content-main">
        <div class="main-nav">
          <div class="nav-item"
               v-for="(item, index) in $t('footer')"
               v-show="$i18n.locale === 'zh_CN'||item.titleEN!='Join us'"
               :key="index">
            <h2 class="item-title">{{ item.titleZH }}<span class="sub-title">{{ item.titleEN }}</span></h2>
            <div v-for="(item, index) in item.children"
                 :key="index">
              <router-link v-if="item.target === 'self'"
                           class="item-route"
                           :to="item.href">{{ item.name }}</router-link>
              <a v-else
                 class="item-route"
                 :href="item.link"
                 target="_blank">{{ item.name }}</a>
            </div>
          </div>
        </div>
        <div class="main-blog">
          <div class="main-consult">
            <div class="consult-item">
              <!-- <div class="item-title" v-if="$i18n.locale != 'zh_CN'">{{$t('foot1.text1')}}</div> -->
              <div class="item-content">
                <!-- <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_tel.png"/>010-58650996 9:00-18:00</div> -->
                <div v-show="$i18n.locale!='zh_CN'">
                  <div class="tel-num" style="color: #fff;margin: 5px 0px 5px 0px;">Overseas Business</div>
                  <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_phone.png"/>+8613466409331 Susie</div>
                <!-- <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_phone.png"/>+8613220114637 Levey Liu</div> -->
                <!-- <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_phone.png"/>+8613091439568 Hongxu cui</div> -->
                <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_phone.png"/>+8613501233621 ابراهيم حسن </div>
                  <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_phone.png"/>+8613220114637 Liu</div>

                </div>

                <div class="tel-num" style="color: #fff;margin: 5px 0px 5px 0px;" v-show="$i18n.locale=='zh_CN'">电话</div>
                <div class="tel-num" v-show="$i18n.locale=='zh_CN'"><img class="tel-img" src="/static/images/footer/foot_tel.png" />010-50947771</div>
              </div>
            </div>
            <div class="consult-item">
              <div class="item-title"
                   >{{$t('foot1.text2')}}</div>
              <div class="item-content">
                <div class="tel-num"><img class="tel-img" src="/static/images/footer/foot_email.png"/>sales@hovwing.com  00:00-24:00</div>
              </div>
            </div>
            <!-- <div class="consult-item consult-item-h5">
              <div class="item-title">售后电话</div>
              <div class="item-content">
                <div class="tel-num">17133852627</div>
                <div class="time-long">08:30-17:30</div>
              </div>
            </div> -->
            <div class="guanwei-main">
              <img class="item-img"
                   src="/static/images/footer/guanwei.jpg">
            </div>
          </div>
        </div>
      </div>
      <div class="main-copy">
        <div class="copy-content">
          <div class="content-item">
            <router-link class="item-img"
                         to="/">
              <img src="/static/images/footer/logo.png">
            </router-link>
            <a class="item-link"
               href="javascript:;">隐私权政策·使用条款</a>
          </div>
          <div class="content-item">
            <span class="item-span">Copyright ©2023 航翊科技 保留所有权利</span>
            <a class="item-link"
               href="https://beian.miit.gov.cn/"
               target="_blank">京ICP备 2023016156号-1</a>
            <a class="item-link"
               href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11022902000453"
               target="_blank"><img style="height:15px;margin-right:5px;vertical-align:middle;"
                   src="/static/images/beian.png"
                   alt="beian">京公网安备 11022902000453 号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {};
  },
  created () { }
};
</script>

<style scoped lang="stylus">
.footer-container {
  min-width: 1200px;
  margin: 0 auto;
  background: #161616;
  .tel-num{
    margin-bottom: 7px;
    display: flex;
    align-items: center
    .tel-img{
      margin-right: 5px;
      width: 16px;
      height: 16px;
    }
  }

  .footer-content {
    .content-main {
      display: flex;
      height: 300px;
      max-width: 1280px;
      // min-width: 1024px;
      margin: 0 auto;
      padding: 40px 0;
      box-sizing: border-box;

      .main-nav {
        width: 50%;

        .nav-item {
          width: 150px;
          display: inline-block;
          vertical-align: top;

          .item-title {
            color: #fff;
            padding-bottom: 20px;

            .sub-title {
              display: block;
              font-size: 12px;
              padding: 2px 0;
            }
          }

          .item-route {
            display: block;
            padding: 10px 0;
            color: #999;

            .prefix {
              color: #007BE7;
              margin-right: 4px;
            }
          }
        }
      }

      .main-blog {
        width: 50%;
        color: #999;

        .main-website {
          padding-bottom: 20px;

          .website-item {
            display: inline-block;
            height: 30px;
            margin-right: 10px;

            .icon-img {
              vertical-align: top;
              height: 100%;
            }
          }
        }

        .main-consult {
          position: relative;

          .consult-item {
            display: inline-block;
            padding-right: 20px;
            vertical-align: top;

            .item-title {
              color:#fff;
              padding-bottom: 20px;
            }

            .item-content {
              margin-top: -8px;
              line-height: 22px;
            }
          }

          .guanwei-main {
            position: absolute;
            top: 0;
            right: 0;

            .item-img {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }

  .main-copy {
    // height: 44px;
    height: 120px;
    background: #212121;
    color: rgba(255, 255, 255, 0.4);

    .copy-content {
      max-width: 1280px;
      // min-width: 1024px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;

      .content-item {
        flex: 1;
        padding: 15px 0;

        .item-img {
          display: inline-block;
          width: 106px;
          margin-right: 20px;
          vertical-align: top;

          img {
            width: 100%;
          }
        }

        .item-link, .item-span {
          line-height: 34px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.4);
        }

        .item-span {
          padding-right: 20px;
        }

        &:last-child {
          text-align: right;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .footer-container {
    min-width: 100%;

    .footer-content {
      .content-main {
        display: block;
        height: auto;
        max-width: 100%;

        .main-nav {
          width: 100%;

          .nav-item {
            width: 120px;
            display: inline-block;
            vertical-align: top;
            text-align: center;
            padding-bottom: 20px;
          }
        }

        .main-blog {
          width: 100%;

          .main-website {
            padding: 0 20px;

            .website-item {
              display: inline-block;
              width: 60px;
              height: 30px;
              margin-right: 0;
              margin-bottom: 20px;

              .icon-img {
                vertical-align: top;
                height: 100%;
              }
            }
          }

          .main-consult {
            padding: 0 20px;

            .consult-item-h5 {
              padding-top: 20px;
            }

            .guanwei-main {
              display: block;
              position: unset;
              margin-top: 40px;
            }
          }
        }
      }
    }

    .main-copy {
      height: auto;

      .copy-content {
        max-width: 100%;
        display: block;

        .content-item {
          padding: 10px 20px;

          .item-link, .item-span {
            line-height: 36px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.4);
            white-space: nowrap;
          }

          &:last-child {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue